<template>
    <loading :active.sync="loading" :is-full-page="fullPage" color="#016BAB"></loading>
</template>

<script>
    //uncomment for vuex state management
    //import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
    import Loading from 'vue-loading-overlay';
    export default {
        //Your local variables for use in the component
        data() {
            return {
                loading: true,
                fullPage: true
            };
        },
        created() {
            try {
                let data = {
                    id: this.$route.query.id,
                    cliLogSource: this.$route.query.ref
                };
                if (this.$route.query.ref) {
                    sessionStorage.setItem("externalLogin", this.$route.query.ref);
                } else {
                    sessionStorage.setItem("externalLogin", document.referrer);
                }
                let rootUrl = window.location.href.replace(this.$route.fullPath, '');
                window.history.replaceState({}, 'Please wait...', rootUrl);
                this.$store.dispatch('preAuthentication', data).then(() => {
                    this.loading = false;
                    this.$router.push('/');
                }).catch(() => {
                    this.loading = false;
                    this.$router.push('/login');
                });
            }
            catch {
                this.$router.push('/login');
            }
        },
        //calculated values, auto reactive
        //functionName: function(){}
        //functionName: { get: function() {}, set: function(value){}}
        computed: {},
        //perform actions, not reactive to variables used
        //functionName: function(arg1,arg2){}
        methods: {},
        /*  data passed in from external
        propName: {
            type: Number,
            default: 42,
            required: false
            required: false
        }
        */
        props: {},
        /* other components need
          you need to import the component first
          'component-a': ComponentA,
        */
        components: {
            Loading
        }
    };
</script>
